import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, withHandlers, compose, branch, renderNothing, lifecycle, withState } from 'recompose'
import onClickOutside from 'react-onclickoutside-decorator'

import * as OrgSelectors from 'app/modules/org/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as AccountSelectors from 'app/modules/account/selectors'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as InboxActions from 'app/modules/inbox/actions'
import * as InboxSelectors from 'app/modules/inbox/selectors'
import { fetchAccountAttribs } from 'app/modules/account/actions'
import { makeHasGate } from 'app/modules/gates/selectors'

import { EmailSenderTypes, EmailFormatTypes, EmailEditSenderModal } from './component'
import { EditSenderLevels } from 'app/modules/playbook/constants'


const STATIC_SENDER = {
  label: 'Drift User',
  value: 'DRIFT_USER',
  type: EmailSenderTypes.STATIC,
}

const ACCOUNT_OWNER = {
  label: (<div>Account Owner  - <span className="email-sender-option-light-text">{'{{ account.ownerId }}'}</span></div>),
  value: 'ownerId',
  type: EmailSenderTypes.DYNAMIC,
}

const LAST_SALES_CONTACTED = {
  label: (<div>Last Sales Contact - <span className="email-sender-option-light-text">{'{{ user.engagedAgent }}'}</span></div>),
  value: 'engagedAgent',
  type: EmailSenderTypes.DYNAMIC,
}

const attribToSendTypeOption = (attrib) => {
  return {
    value: attrib.name,
    label: (<div>{attrib.label} - <span className="email-sender-option-light-text">{`{{ account.${attrib.name} }}`}</span></div>),
    type: EmailSenderTypes.DYNAMIC,
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setSequenceSenderName: PlaybookActions.setSequenceSenderName,
      setSequenceEmailOverride: PlaybookActions.setSequenceEmailOverride,
      setSequenceDynamicAccountSendAttribute: PlaybookActions.setSequenceDynamicAccountSendAttribute,
      setSequenceAuthorId: PlaybookActions.setSequenceAuthorId,
      setSenderName: PlaybookActions.setSenderName,
      setEmailOverride: PlaybookActions.setEmailOverride,
      setAuthorId: PlaybookActions.setAuthorId,
      setDynamicAccountSendAttribute: PlaybookActions.setDynamicAccountSendAttribute,
      setSequenceDynamicSenderFormat: PlaybookActions.setSequenceDynamicSenderFormat,
      setDynamicSenderFormat: PlaybookActions.setDynamicSenderFormat,
      fetchAccountAttribs,
      fetchInboxList: InboxActions.fetchInboxList,
      hideEditSenderModal: PlaybookActions.hideEditSenderModal,
      setSequenceIndividualSenderName: PlaybookActions.setSequenceIndividualSenderName,
      setSequenceIndividualEmailOverride: PlaybookActions.setSequenceIndividualEmailOverride,
      setSequenceIndividualDynamicAttr: PlaybookActions.setSequenceIndividualDynamicAttr,
      setSequenceIndividualDynamicFormat: PlaybookActions.setSequenceIndividualDynamicFormat,
    },
    dispatch
  ),
})

const mapStateToProps = state => ({
  emailMessage: PlaybookSelectors.emailMessage(state),
  org: OrgSelectors.org(state),
  orgUsers: UserSelectors.currentOrgUsersAlphabetical(state),
  currentUser: UserSelectors.currentUser(state),
  dynamicSenderTypes: AccountSelectors.teamMemberAttribs(state),
  isSequence: PlaybookSelectors.getIsSequencePlaybook(state),
  sequenceDynamicAccountSendAttribute: PlaybookSelectors.sequenceDynamicSendAttribute(state),
  sequenceDynamicSenderFormat: PlaybookSelectors.sequenceDynamicSenderFormat(state),
  dynamicAccountSendAttribute: PlaybookSelectors.dynamicAccountSendAttribute(state),
  dynamicSenderFormat: PlaybookSelectors.dynamicSenderFormat(state),
  senderEmailOverride: PlaybookSelectors.senderEmailOverride(state),
  sendFromOverride: PlaybookSelectors.sendFromOverride(state),
  sequenceSenderEmailOverride: PlaybookSelectors.sequenceSenderEmailOverride(state),
  sequenceSendFromOverride: PlaybookSelectors.sequenceSendFromOverride(state),
  sequenceAuthorId: PlaybookSelectors.sequenceAuthorId(state),
  authorId: PlaybookSelectors.authorId(state),
  isInboxListLoading: InboxSelectors.isInboxListLoading(state),
  isInboxListLoaded: InboxSelectors.isInboxListLoaded(state),
  inboxes: InboxSelectors.inboxes(state),
  editSenderLevel: PlaybookSelectors.getEditSenderLevel(state),
  editingEmailId: PlaybookSelectors.getEditSenderModalEditingEmailId(state),
  emails: PlaybookSelectors.emails(state),
  hasDynamicAccountBasedSender: makeHasGate('ABM')(state),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const { actions, isInboxListLoaded, isInboxListLoading } = this.props
      if (!isInboxListLoaded && !isInboxListLoading) {
        actions.fetchInboxList()
      }
    },
  }),
  branch(({ orgUsers, isInboxListLoaded }) => !orgUsers.size || !isInboxListLoaded, renderNothing),
  withProps(props => {
    const inboxEmailIsOverride = !!props.inboxes.find(inbox => inbox.get('address') === senderEmailOverride)
    let senderEmailOverride = props.senderEmailOverride
    let sendFromOverride = props.sendFromOverride
    let authorId = props.authorId
    let setSenderNameAction = props.actions.setSenderName
    let setEmailOverrideAction = props.actions.setEmailOverride
    let setDynamicAccountSendAttributeAction = props.actions.setDynamicAccountSendAttribute
    let setDynamicSenderFormatAction = props.actions.setDynamicAccountSenderFormat
    let dynamicAccountSendAttribute = props.dynamicAccountSendAttribute
    let dynamicSenderFormat = props.dynamicSenderFormat
    if (props.isSequence) {
      senderEmailOverride = props.sequenceSenderEmailOverride
      sendFromOverride = props.sequenceSendFromOverride
      authorId = props.sequenceAuthorId
      setSenderNameAction = props.actions.setSequenceSenderName
      setEmailOverrideAction = props.actions.setSequenceEmailOverride
      setDynamicAccountSendAttributeAction = props.actions.setSequenceDynamicAccountSendAttribute
      setDynamicSenderFormatAction = props.actions.setSequenceDynamicSenderFormat
      dynamicAccountSendAttribute = props.sequenceDynamicAccountSendAttribute
      dynamicSenderFormat = props.sequenceDynamicSenderFormat

      if (props.editSenderLevel === EditSenderLevels.LOCAL) {
        const email = props.emails.get(props.editingEmailId)
        senderEmailOverride = email.get('senderEmailOverride')
        sendFromOverride = email.get('sendFromOverride')
        dynamicAccountSendAttribute = email.get('dynamicAccountSendAttribute')
        dynamicSenderFormat = email.get('dynamicSenderFormat')
        setSenderNameAction = (name) => props.actions.setSequenceIndividualSenderName({ data: name, emailId: props.editingEmailId })
        setEmailOverrideAction = (email) => props.actions.setSequenceIndividualEmailOverride({ data: email, emailId: props.editingEmailId })
        setDynamicAccountSendAttributeAction = (attr) => props.actions.setSequenceIndividualDynamicAttr({ data: attr, emailId: props.editingEmailId })
        setDynamicSenderFormatAction = (format) => props.actions.setSequenceIndividualDynamicFormat({ data: format, emailId: props.editingEmailId })
      }
    }
    const selectedUserId = inboxEmailIsOverride ? senderEmailOverride : authorId

    if (props.isSequence) {
      return {
        authorId,
        setSenderNameAction,
        setEmailOverrideAction,
        setDynamicAccountSendAttributeAction,
        setDynamicSenderFormatAction,
        setAuthorIdAction: props.actions.setSequenceAuthorId,
        dynamicSenderFormat,
        dynamicAccountSendAttribute,
        senderEmailOverride,
        sendFromOverride,
        selectedUserId,
        defaultUser: props.orgUsers.toJS().find(user => user.id === authorId || user.email === authorId) || props.orgUsers.first().toJS(),
      }
    } else {
      return {
        authorId,
        setSenderNameAction,
        setEmailOverrideAction,
        setDynamicAccountSendAttributeAction,
        setDynamicSenderFormatAction,
        setAuthorIdAction: props.actions.setAuthorId,
        dynamicSenderFormat,
        dynamicAccountSendAttribute,
        senderEmailOverride,
        sendFromOverride,
        selectedUserId,
        defaultUser: props.orgUsers.toJS().find(user => user.id === authorId || user.email === authorId) || props.orgUsers.first().toJS(),
      }
    }
  }),
  branch(({ orgUsers }) => !orgUsers.size, renderNothing),
  lifecycle({
    componentDidMount() {
      if (this.props.hasDynamicAccountBasedSender) {
        this.props.actions.fetchAccountAttribs()
      }
    },
  }),
  withState('selectedSenderType', 'setSelectedSenderType', props => !!props.dynamicAccountSendAttribute ? EmailSenderTypes.DYNAMIC : EmailSenderTypes.STATIC),
  withState('selectedSenderChoice', 'setSelectedSenderChoice', props => props.dynamicAccountSendAttribute || STATIC_SENDER.value),
  withState('formatType', 'setFormatType', props => props.dynamicSenderFormat || EmailFormatTypes.FIRST_LAST),
  withState('dynamicSendAttribute', 'setDynamicSendAttribute', props => props.dynamicAccountSendAttribute),
  withState('staticSendName', 'setStaticSendName', props => props.sendFromOverride || _.get(props, 'emailMessage.sendFromOverride')),
  withState('staticSendEmail', 'setStaticSendEmail', props => props.senderEmailOverride),
  withState('selectedAuthorId', 'setSelectedAuthorId', props => props.authorId),
  withState('selectedOption', 'setSelectedOption', props => props.senderEmailOverride),
  withHandlers({
    onSenderTypeSelect: props => ({ value, type }) => {
      props.setSelectedSenderType(type)
      props.setSelectedSenderChoice(value)
      if (type === EmailSenderTypes.DYNAMIC) {
        props.setDynamicSendAttribute(value)
      } else {
        props.setDynamicSendAttribute(null)
      }
    },
    onFormatSelect: props => formatType => {
      props.setFormatType(formatType)
    },
    onStaticSendNameChange: props => e => {
      props.setStaticSendName(e.target.value)
    },
    hideModal: props => () => {
      props.actions.hideEditSenderModal()
    },
    renderSelectedUser: props => () => ((
      <div className="Select-value">
        <span className="Select-value-label">{props.staticSendEmail || props.defaultUser.email}</span>
      </div>
    )),
    onUserIdChange: props => (option) => {
      props.setSelectedOption(option)
      if (option.isInbox) {
        props.setSelectedAuthorId(props.currentUser.get('id', 0))
        props.setStaticSendEmail(option.value)
      } else {
        props.setSelectedAuthorId(option.value)
        const sendFromAuthor = props.orgUsers.find(user => user.id === option.value)
        sendFromAuthor && props.setStaticSendEmail(sendFromAuthor.email)
      }
    },
    onSave: props => () => {
      props.setSenderNameAction(props.staticSendName)
      props.setEmailOverrideAction(props.staticSendEmail)
      props.setAuthorIdAction(props.selectedAuthorId)
      props.setDynamicAccountSendAttributeAction(props.dynamicSendAttribute)
      props.setDynamicSenderFormatAction(props.formatType)
      props.actions.hideEditSenderModal()
    },
  }),
  withProps(props => ({
    exampleUser: props.currentUser || props.orgUsers.first(),
    senderChoices: [STATIC_SENDER, LAST_SALES_CONTACTED].concat(props.hasDynamicAccountBasedSender ? [ACCOUNT_OWNER] : []).concat(props.dynamicSenderTypes.map(attribToSendTypeOption).toJS())
  })),
  onClickOutside
)(EmailEditSenderModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailEditSenderModal/index.js